import {
  Modal,
  ModalCloseIconButton,
  ModalContent,
  ModalTitle,
  Typography,
  ModalActions,
  ModalActionButton,
} from '@ace-clublabs/shared-component-library';

export interface HowToMakeChangeModalProps {
  showHowToMakeChangeModal: boolean;
  closeModal: () => void;
}

export const HowToMakeChangeModal: (props: HowToMakeChangeModalProps) => JSX.Element = (props) => (
  <Modal
    className="how-to-make-change-modal"
    open={props.showHowToMakeChangeModal}
    size="medium"
    onClose={() => {
      props.closeModal();
    }}
    variants={{
      xs: 'bottom-sheet',
      sm: 'bottom-sheet',
      md: 'regular',
      lg: 'regular',
    }}
  >
    <ModalTitle id="howtoMakeChangeModalTitle" sx={{ marginRight: '2rem', display: 'flex' }}>
      <Typography variant="h5">Need to make changes, downgrade, or cancel?</Typography>
      <ModalCloseIconButton
        aria-label="Close"
        id="howtoMakeChangeButton"
        onClick={() => {
          props.closeModal();
        }}
      />
    </ModalTitle>
    <ModalContent id="howtoMakeChangeContent">
      <Typography variant="b1Regular" sx={{ marginBottom: '1rem' }}>
        We are committed to providing you with legendary service. For changes that cannot be made online, such as
        downgrading or canceling your membership, please visit a branch or call us.
      </Typography>
      <Typography variant="b1Regular" sx={{ marginBottom: '1rem' }}>
        <strong>Membership services hours: </strong>
        <br />
        Monday–Friday: 8 a.m. to 7 p.m.
        <br />
        Saturday: 8 a.m. to 5 p.m.
      </Typography>
      <Typography variant="b1Regular" sx={{ marginBottom: '1rem' }}>
        You’ll receive a pro-rata refund of your paid dues, excluding any new member admission fees and discounts.
      </Typography>
    </ModalContent>
    <ModalActions
      actionLayout={{
        sm: 'fullWidth',
        md: 'fullWidth',
        lg: 'rightAlign',
        xl: 'rightAlign',
      }}
    >
      <ModalActionButton
        sx={{
          color: '#1C4DA6;',
          backgroundColor: '#FFFFFF',
          borderRadius: '6px',
          padding: '9px !important',
          ':hover': { cursor: 'pointer', backgroundColor: '#EFF7FE' },
        }}
        id="modalCallButton"
        label="Call 1-844-786-1615"
        onClick={() => {
          window.open('tel:18447861615');
        }}
      />
      <ModalActionButton
        id="modalFindButton"
        label="Find a branch"
        onClick={() => {
          window.open('https://ace.aaa.com/locations.html');
        }}
      />
    </ModalActions>
  </Modal>
);
